import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { ContentBlock } from '../../models';
import { Store } from '@ngrx/store';
import * as fromShopify from 'src/app/shop';
import { InViewportDirective } from '@teamfoster/sdk/in-view';
import { ProductCardComponent } from '../../../catalog/components/product-card/product-card.component';
import { AsyncPipe } from '@angular/common';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-content-block-product-catalog',
  templateUrl: './content-block-product-catalog.component.html',
  styleUrls: ['./content-block-product-catalog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InViewportDirective, ProductCardComponent, AsyncPipe, FromDictionaryPipe],
})
export class ContentBlockProductCatalogComponent {
  private store = inject(Store);

  @Input() block!: ContentBlock;

  products$ = this.store.select(fromShopify.getAllProducts);
  loading$ = this.store.select(fromShopify.getProductsLoading);
  page$ = this.store.select(fromShopify.getProductsPageInfo);

  constructor() {}

  loadProducts(): void {
    this.store.dispatch(fromShopify.LoadProductsForCollection({ handle: this.block.featuredCollectionHandle }));
  }

  loadMore() {
    this.store.dispatch(fromShopify.LoadMoreProductsForCollection());
  }

  trackByFn(index: number, item: fromShopify.Product) {
    return item?.id;
  }
}
